import React, { useEffect, useRef, useState } from 'react';
import cx from 'classnames';
import './styles.scss';
import InputPostPe from '../InputPostPe';
import CardPostPe from '../CardPostPe';
import Screen from '../Screen';
import ActionBlock from '../ActionBlock';
import Footer from '@bharatpe/bharat-ui/web/Footer';
import Button from '@bharatpe/bharat-ui/web/Button';
import Typography from '@bharatpe/bharat-ui/web/Typography';
import { makeStyles } from '@bharatpe/bharat-ui/web/Styles';
import { showPostPeUI, showTwelvePcUI } from 'utils/Utils';

const isShowTwelvePcUI = showTwelvePcUI();
const isShowPostPeUI = showPostPeUI();

const useStyle = makeStyles(() => ({
	footerNewContainer: {
		bottom: '0',
		left: '0',
		zIndex: 9,
		background: '#ffffff',
	},
	twelvePcButton: {
		background: '#035857',
		borderRadius: '48px',
		padding: '14px 30px',
		textAlign: 'center',
		display: 'inline-block',
		width: '90%',
		color: '#ffffff',
	},
	twelvePcButtonDisabled: {
		background: '#D0D0D0',
		borderRadius: '48px',
		padding: '14px 30px',
		textAlign: 'center',
		display: 'inline-block',
		width: '90%',
		color: '#ffffff',
	},
	twelvePcButtonOutline: {
		background: '#ffffff',
		borderRadius: '48px',
		padding: '14px 30px',
		textAlign: 'center',
		display: 'inline-block',
		width: '90%',
		color: '#035857',
		border: '1px solid #035857',
	},
	width100Imp: {
		width: '100% !important',
	},
	bharatpeIcon: {
		width: '18px',
	},
	bottomBlock: {
		background: '#ffffff',
		height: '70px',
	},
	postpeButton: {
		border: '1px solid #009CDE',
		borderRadius: '10px',
		textAlign: 'center',
		display: 'inline-block',
		width: '90%',
		background: 'linear-gradient(to right, #66BEEF, #009CDE)',
		color: '#FFFFFF',
		fontSize: '1rem',
		fontFamily: 'PoppinsExtraHeavy',
		padding: '12px 18px',
		textTransform: 'capitalize',
		outline: 'none',
	},
}));

const BankList = ({ bankList: { data = [], status = false }, bankSelectedCallback, payNowCallback }) => {
	const classes = useStyle();
	const inputRef = useRef(null);
	const [bankSearchValue, setBankSearchValue] = useState('');
	const [bank, setBank] = useState('');
	const [searchedBanks, setSearchedBanks] = useState(null);
	const [isBankFound, setIsBankFound] = useState(false);

	useEffect(() => {
		if (status && data.length > 0) {
			let searchableArray = data;
			searchableArray = searchableArray?.map((item) => {
				setIsBankFound(true);
				return {
					...item,
					show: true,
				};
			});
			setSearchedBanks(searchableArray);
		}
	}, [status]);

	//Return UI
	return (
		<Screen screenClass="bank-list-screen h-90">
			<InputPostPe
				inputRef={inputRef}
				type={'text'}
				onChange={({ target }) => {
					let value = target.value;
					value = value.replace(/[^\w /]/gi, '');
					let searchingArray = [...searchedBanks];
					let isBankShow = false;
					searchingArray = searchingArray?.map((item, index) => {
						if (item['displayName'].toLowerCase().includes(value.toLowerCase())) isBankShow = true;
						return {
							...item,
							show: item['displayName'].toLowerCase().includes(value.toLowerCase()),
						};
					});
					if (isBankShow) setIsBankFound(true);
					else setIsBankFound(false);
					setSearchedBanks([...searchingArray]);
					setBankSearchValue(value);
				}}
				value={bankSearchValue}
				inputClassName="mr-b-20 animated fadeInRight"
				placeholder="Search Bank"
				inputContainerClassName="w-94"
			/>
			<CardPostPe variant="white" cardClass="bank-list animated fadeInRight h-75 overflow-scroll padding-bank-list">
				{searchedBanks?.map((item, index) => {
					let finalIndex = 0;
					finalIndex = `0.0${(index / 10).toString().split('.')[1]}s`;
					return (
						item.show && (
							<ActionBlock
								key={index}
								activeBlockClass={cx(data.length - 1 !== index ? 'border-bottom' : 'no-border')}
								activeBlockStyle={{ animationDelay: finalIndex }}
								onClick={() => {
									setBank(item?.gatewayBankCode);
									bankSelectedCallback(item?.gatewayBankCode);
								}}
								img={
									item?.image
										? item?.image
										: 'https://d30gqtvesfc1d5.cloudfront.net/ext/app_essential/Images/bank_icon/bank_default.png'
								}
								text={item['displayName']}
								isItemSelected={item?.gatewayBankCode === bank}
							/>
						)
					);
				})}
				{!isBankFound && (
					<div className="text-center p4">
						<Typography variant="SemiBold600" className="">
							No Banks Found
						</Typography>
					</div>
				)}
			</CardPostPe>
			{isShowTwelvePcUI ? (
				<>
					<div className={classes.bottomBlock}></div>
					<div className={`${classes.footerNewContainer} pb4 px1 flex flex-center flex-justify-center width-100 fixed`}>
						<button
							className={`${classes.twelvePcButton} ${!bank ? classes.twelvePcButtonDisabled : ''} fs-14`}
							onClick={payNowCallback}
							disabled={!bank}>
							PAY NOW
						</button>
					</div>
				</>
			) : isShowPostPeUI ? (
				<Footer>
					<button
						className={`${!bank ? 'postpeButtonDisabledBank' : 'postpeButtonBank'} width-100`}
						onClick={payNowCallback}
						disabled={!bank}>
						PAY NOW
					</button>
				</Footer>
			) : (
				<Footer>
					<Button size="large" onClick={payNowCallback} disabled={!bank}>
						PAY NOW
					</Button>
				</Footer>
			)}
		</Screen>
	);
};

export default BankList;
